export default "__VITE_ASSET__CAkSC$LX__"